import type { Pin } from '@/interfaces'

export const organizationPins: Pin[] = ([
    {
        "_id": "organization_muf",
        "email": "",
        "title": "Mladi u fokusu",
        "location": "Split",
        "description": "Youth club - Exchanges and trainings - Board games designing - Environmental work \nhttps://oip-posejdon.wixsite.com/home",
        "like_id": [],
        "file_id": [],
        "comment_id": [],
        "approved": true,
        "x": 566,
        "y": 373,
        "createdAt": new Date(),
        "updatedAt": new Date(),
    },
    {
        "_id": "organization_argonauta",
        "email": "",
        "title": "Argonauta",
        "location": "Murter",
        "description": "Association for nature - Environment conservation - Sustainable development - Promotion Argonauta \nhttps://argonauta.hr",
        "like_id": [],
        "file_id": [],
        "comment_id": [],
        "approved": true,
        "x": 564,
        "y": 371,
        "createdAt": new Date(),
        "updatedAt": new Date(),
    },
    {
        "_id": "organization_elegast",
        "email": "",
        "title": "Elegast",
        "location": "Antwerpen",
        "description": "Special youth care - Social community work - family support \nhttps://www.elegast.be",
        "like_id": [],
        "file_id": [],
        "comment_id": [],
        "approved": true,
        "x": 537,
        "y": 345,
        "createdAt": new Date(),
        "updatedAt": new Date(),
    },
    {
        "_id": "organization_producoes",
        "email": "",
        "title": "Produções Fixe",
        "location": "Vila da Marmeleira",
        "description": "Training - Board game development & production - Community building - Fablab - Participation \nhttps://www.facebook.com/ProducoesFixe",
        "like_id": [],
        "file_id": [],
        "comment_id": [],
        "approved": true,
        "x": 498,
        "y": 390,
        "createdAt": new Date(),
        "updatedAt": new Date(),
    },
    {
        "_id": "organization_promesas",
        "email": "",
        "title": "Promesas",
        "location": "Alicante",
        "description": "Creative Learning Environments - Educational Game Design - Mental Health Trainings \nhttps://www.promesas.eu",
        "like_id": [],
        "file_id": [],
        "comment_id": [],
        "approved": true,
        "x": 521,
        "y": 391,
        "createdAt": new Date(),
        "updatedAt": new Date(),
    },
    {
        "_id": "organization_marttinen",
        "email": "",
        "title": "Youth Centre Marttinen",
        "location": "Virrat",
        "description": "Valuable youth work - Respect for life and nature - Genuine experience - Developing community \nhttps://www.marttinen.fi",
        "like_id": [],
        "file_id": [],
        "comment_id": [],
        "approved": true,
        "x": 590,
        "y": 286,
        "createdAt": new Date(),
        "updatedAt": new Date(),
    }
])